import { getFeatureFlagValue } from "state/featureFlags";

import { useSelector } from "./redux";

import type { CLOUD_API } from "@skydio/api_util/src";

export const useFeatureFlag = (feature: keyof CLOUD_API.FeatureFlags) =>
  useSelector(state => getFeatureFlagValue(state, feature));
